import type { Schema } from "../../..";
import type { Parser } from "../parser";

export class ModulesNameParser implements Parser {
	parse(schema: Record<string, Schema.Module>) {
		const names = Object.keys(schema).map((name) => `"${name}"`);

		return names.length ? `export type Modules = ${names.join("|")}` : "";
	}
}
